import { Global, Module } from '@nestjs/common';
import { PlanLimitsController } from './plan-limits.controller';
import { PlanLimitsService } from './plan-limits.service';

@Global()
@Module({
  controllers: [PlanLimitsController],
  providers: [PlanLimitsService],
  exports: [PlanLimitsService],
})
export class PlanLimitsModule {}
